
    import Vue from "vue";

    export default Vue.extend({
        name: "RomaConfirmDialog",
        props: {
            loading: {
              type: Boolean,
              required: false,
              default: false,
            },
            value: Boolean,
            title: {
                type: String,
                default: '¿Realmente deseas eliminar el item seleccionado?'
            },
            textBtnNo: {
                type: String,
                default: 'Cancelar'
            },
            textBtnOk: {
                type: String,
                default: 'Eliminar'
            },
            actionBtnNo: {
                type: Function,
                default () {
                    this.toggleShow(false);
                }
            },
            actionBtnOk: {
                type: Function,
                default () {
                    this.toggleShow(false);
                }
            },
        },
        data() {
            return {
                show: false,
            };
        },
        methods: {
          toggleShow (value: Boolean) {
              this.$emit('input', value);
          }
        },
    });
